export class ICptOrdersComponent {
    cptOrderId: number;
    patientId: number;
    encounterId: string;
    cptCode: string;
    cptDescription: string;
    notes: string;
    abn: string;
    outSide: boolean;
    isActive: boolean;
    cptDate: Date;
    ordersDx: IOrdersDx[];
    createdBy: string;
    createdOn: Date;
    modifiedBy: string;
    modifiedOn: Date;
    displayordersDx: string[];
    isPast: boolean;
    background: string;
    categoryId: number;
    categoryName: string;
    facilityProviderDescription: string;
    facilityProviderId: number;
    orderStatus: string;
    routeStatus: string;
    providerName: string;
    providerId: string;
    printStatus: boolean;
    faxStatus: boolean;
    fileExt: string;
    importOrderId: number;
    patientName: string;
    side: string;
    extremity: string;
    encounterType?: string;
    patId: number;
    createdOndate: string;
    IsGroupOrder?: boolean;
    type?: string;
    DMId: string;
    locationId?: number;
    DMstatus?: string;
    Browse?:string;
}


export interface IOrdersCategory {

    categoryId: number;
    categoryName: string;
    parentCategoryId: number;
    expanded?: boolean;
    ordersChildSystems: IOrdersCategory[];
    selected: boolean;
    isActive: boolean;
    background: string;
}

export interface IOrdersCPTCodes {
    categoryCptId: number;
    categoryId: number;
    cptCode: string;
    cptDescription: string;
    isActive: boolean;
    background: string;
    categoryName: string;
    extremity: string;
    side: string;
}
export interface IOrdersLoinc {
    categoryName: string;
    loincNumber: string;
    loincCommanName: string;
    orderObs: string;
    categoryId: number;
    background: string;
    EncounterId: string;
    Description: string;
    type: string;
    PatientId: string;
    loincDescription: string;
}
export class IManualOrdersCPTCodes {
    cptOrderId: number;
    testName: string;
    testCPT: string;
    Result: string;
    ValueandUnit: string;
    date: string;
    referenceRange: string;
    OrderDesc: string;
    facilityProviderId: number;
    resultstatus: string;
}

export interface IOrdersDx {
    // orderDxId: number;    
    // cptOrderId:number;
    icdCode: string;
    // icdCodeDescription: string;
    // isActive: boolean;
}

export interface ICptOrdersCompDetails {
    EncOrders: ICptOrdersComponent[];
    PatAllOrders: ICptOrdersComponent[];
}

